import {API} from "../api.js";
import {decodeSvgFromDataUrl, fileToDataUrl, isSvgFile} from "../libs/bg-utils";
import {encodeInlineSvg, INLINE_SVG_MAX_BYTES} from "../data/inline-svg";
import {assetUrl} from "./schema";
import {UPLOAD_MAX_BYTES} from "../data/constants";

export async function uploadBannerAsset(file: File, signal?: AbortSignal): Promise<string> {
  signal?.throwIfAborted();
  if (file.size > UPLOAD_MAX_BYTES) throw new Error("Asset exceeds 50 MiB upload limit");
  if (isSvgFile(file)) {
    if (file.size > INLINE_SVG_MAX_BYTES) throw new Error("Inline SVG exceeds 256 KiB");
    const markup = decodeSvgFromDataUrl(await fileToDataUrl(file));
    signal?.throwIfAborted();
    if (!markup) throw new Error("Invalid SVG asset");
    return encodeInlineSvg(markup);
  }
  const result = await API.uploadFile(file);
  signal?.throwIfAborted();
  if (!result?.url) throw new Error("Upload API returned no URL");
  return assetUrl(result.url, "upload.url");
}
